const userRoutes = [
  {
    path: 'user/profile',
    name: 'UserProfile',
    component: () => import('../views/user/UserProfile.vue'),
    meta: { module: 'user' }
  },
  {
    path: 'user/payment',
    name: 'UserPayment',
    component: () => import('../views/user/Payment.vue'),
    meta: { module: 'user' }
  }
];

export default userRoutes; 